import React from 'react';
import { isMobile } from 'react-device-detect';
import messages from '../messages';
import { useIntl } from 'react-intl';
import LoungeAccessTrip from './LoungeAccessTrip';

const LoungeAccess = (props: any) => {
  const { data } = props;
  const { formatMessage } = useIntl();

  return (
    <div style={containerStyles}>
      <div className="flex flex-col" style={{ gap: '6px' }}>
        <div className="flex flex-col" style={{ gap: '6px' }}>
          <span style={headerStyles}>
            {formatMessage(messages.loungeAccessHeader)}
          </span>
          <span style={textStyles}>
            {formatMessage(messages.loungeAccessDescription)}
          </span>
        </div>
        <div>
          {data?.[0]?.subscriptionTrips?.map((trip: any) =>
            trip.subscriptionFlights.map(
              (flight: any) =>
                trip?.status !== 'Declined' &&
                flight?.qr_code && (
                  <div style={{ margin: '6px 0' }}>
                    <LoungeAccessTrip flight={flight} />
                  </div>
                )
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default LoungeAccess;

const containerStyles = {
  width: '100%',
  padding: '34px',
  borderRadius: '12px',
  gap: '25px',
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 4px 8px -2px #1018281A',
};

const headerStyles = {
  fontWeight: 600,
  fontSize: '30px',
  lineHeight: '36.31px',
  color: '#101828',
  letterSpacing: '-2%',
  textAlign: isMobile ? 'center' : 'left',
};

const textStyles = {
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '16.94px',
  letterSpacing: '0%',
  coolor: '#101828',
};
